import React from "react";
import { ProjectContextProvider } from "../../context/project_context";
import ProjectByStatus from "./ProjectByStatus";

const Main = ({ org_id, project_id, member_mode = false }) => {

  return(
    <ProjectContextProvider OrgID={org_id} ProjectID={project_id} memberMode={member_mode}>
      <ProjectByStatus />
    </ProjectContextProvider>
  )
}

export default Main;
